<div class="input-group d-inline-flex align-items-center">
    <input
        type="number"
        [formControl]="numberInputControl"
        [placeholder]="model.options.placeholder"
        (blur)="onBlur()"
        (focus)="onFocus()"
        class="form-control input-md number-input"
        paceCoreValidationMessage
        [validation]="numberInputControl"
        [attr.aria-label]="ariaLabel"
        [readonly]="model.options.allowReadonlyValidation"
    />
    <div *ngIf="model.options.scannable">
        <button
            class="btn btn-secondary"
            [disabled]="model.options.readonly"
            type="button"
            (click)="doScan()"
            [attr.aria-label]="'BARCODE_SCANNER_SET_TITLE' | translate"
        >
            <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
        </button>
    </div>
    <div *ngIf="model.options.unit" id="unit">
        <span class="input-group-text">{{ model.options.unit }}</span>
    </div>
</div>
